import type { ProviderId } from '@atlassian/jira-development-common/src/model/releases-data.tsx';

export const UNKNOWN_PROVIDER_ID: ProviderId = '<unknown>';

export const VERSION_RELATED_LINKS_PROVIDER_ID_STG = 'vyhOd8hgbSa4rzgnTvyaZNSUqUViKIOc';
export const VERSION_RELATED_LINKS_PROVIDER_ID_PROD = 'oAPCjkrphiFxmqbTLkv9r2jBFTvfOI8x';
